import { CreditRateTermCodes } from '../interfaces/creditRates';

// 3 - 5 лет
export const INITIAL_TERM_CODE: CreditRateTermCodes = 'about_5_years';
